
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const ContentCalendar: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Your Content Calendar</CardTitle>
        <CardDescription>Upcoming scheduled content</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="p-3 bg-muted/30 rounded-md">
            <div className="flex justify-between items-start mb-1">
              <h3 className="font-medium">Album Teaser</h3>
              <Badge variant="outline" className="text-xs">Tomorrow</Badge>
            </div>
            <p className="text-sm text-muted-foreground">Short clip of your upcoming album with visual effects</p>
          </div>
          
          <div className="p-3 bg-muted/30 rounded-md">
            <div className="flex justify-between items-start mb-1">
              <h3 className="font-medium">Studio Tour</h3>
              <Badge variant="outline" className="text-xs">Aug 15</Badge>
            </div>
            <p className="text-sm text-muted-foreground">YouTube short showcasing your home studio setup</p>
          </div>
          
          <Button variant="outline" className="w-full">
            View Full Calendar
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ContentCalendar;
